<template>
  <div
    v-if="data?.length > 0"
    class="horizontal-banners mb32"
    :class="{ 'edv-banner-wrap': dataType == 'EDV' }"
    id="undefined-horizontal-banner"
    :counterTextObserver="productObserver"
  >
    <div
      v-if="modulePropsData?.title"
      class="banners-title mb10 pl12 bold flex-row"
    >
      <span class="lh21 fs-18">{{ modulePropsData.title }}</span>
      <!-- <span v-if="modulePropsData.subTitle" class="lh16 fs-14">{{modulePropsData.subTitle}}</span> -->
    </div>
    <!-- Intersection Observer -->
    <Observer :options="{ rootMargin: '-50px' }" @intersect="itisvisible" />
    <Carousel
      :pauseAutoplayOnHover="true"
      :transition="500"
      :itemsToShow="itemsToShow"
    >
      <Slide v-for="(item, index) in data" :key="index">
        <div
          @touchstart.stop
          @touchmove.stop
          @click="goto(item, index)"
          class="horz-img-wrap pb10"
        >
          <template
            v-if="queryData2?.[index]?.logo || item?.logo || item?.imageUrl"
          >
            <lazy-image
              class="banners-item flex-row fs-20"
              :class="{
                'edv-banner-image': dataType == 'EDV',
                'banner-height': dataType !== 'EDV',
              }"
              alt="edv image"
              :src="
                dataType == 'EDV'
                  ? (queryData2?.[index]?.logo ||
                      item?.logo ||
                      item?.imageUrl) + getSitePropsOfferVersion()
                  : item?.imageUrl + getSitePropsOfferVersion()
              "
              :src-placeholder="
                staticImgBaseUrl + '/images/global/default-banner.png'
              "
            />
          </template>
          <template v-else>
            <lazy-image
              alt="default image"
              class="banners-item flex-row fs-20"
              :src="staticImgBaseUrl + '/images/global/default-product-img.png'"
            />
          </template>
        </div>
        <Observer @intersect="updateCurrentSlide(index)" />
      </Slide>
      <template #addons> </template>
    </Carousel>
  </div>
</template>

<script setup>
import LazyImage from "./LazyImage.vue";
</script>
<script>
import { Carousel, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import Utility from "../helpers/utility";
import setEvents from "../helpers/events";
import {
  v2PwaBasePath,
  staticImgBaseUrl,
  projectBasePathWithFolder,
} from "../config/apiEndpoints";
import Observer from "../assets/Observer.vue";
import userActivityTracking from "../helpers/UserActivityTracking";
import {
  VWO_NEXTGEN_HOMEPAGE_EXPERIMENT,
  VWO_NEXTGEN_EXPERIMENT_VARIANTS,
} from "../config/vwoKeys";
import localStorageFunc from "../helpers/localStorageFunc";
import PageNames from "../config/pageNames";

export default {
  name: "HorizontalBanners",
  props: ["dataResults", "moduleProps", "dataType", "queryData"],

  components: {
    Carousel,
    Slide,
    Observer,
  },
  data() {
    return {
      data: [],
      modulePropsData: {},
      itemsToShow: 1,
      currentSlide: 0,
      queryData2: [],
      staticImgBaseUrl: staticImgBaseUrl,
      eleIdToObserve: "undefined-horizontal-banner",
    };
  },
  mounted() {
    this.data =
      typeof this.dataResults != null &&
      typeof this.dataResults != "null" &&
      typeof this.dataResults != "undefined"
        ? JSON.parse(this.dataResults)
        : [];
    this.queryData2 =
      typeof this.queryData != null &&
      typeof this.queryData != "null" &&
      typeof this.queryData != "undefined"
        ? JSON.parse(this.queryData)
        : [];

    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};
    this.itemsToShow = +this.modulePropsData?.itemsInScreen;

    if (
      this.productObserver &&
      this.eleIdToObserve &&
      document.getElementById(this.eleIdToObserve)
    ) {
      this.productObserver.observe(
        document.getElementById(this.eleIdToObserve)
      );
    }
  },
  destroyed() {
    if (this.observer) {
      this.observer.unobserve(document.getElementById(this.eleIdToObserve));
    }
  },
  methods: {
    itisvisible() {
      if (this.data && this.data?.length > 0) {
        //Amplitude impression event load
        let sectionName = "marketing banner";
        if (this.dataType && this.dataType == "EDV") sectionName = "EDV";
        const preEventObj = {
          positionWithinSection: this.currentSlide + 1,
          category: this.data[this.currentSlide]?.imageUrl,
        };
        const eventObj = Utility.amplitudeEventObj(
          "impression",
          sectionName,
          this.dataType == "EDV" ? "10" : "8",
          preEventObj
        );
        setEvents("amplitude", "Impression", eventObj);
      }
    },
    updateCurrentSlide(slideVal) {
      this.currentSlide = slideVal;
      //Amplitude impression event load
      let sectionName = "marketing banner";
      if (this.dataType && this.dataType == "EDV") sectionName = "EDV";
      const preEventObj = {
        positionWithinSection: slideVal + 1,
        category: this.data[slideVal]?.imageUrl,
      };
      const eventObj = Utility.amplitudeEventObj(
        "impression",
        sectionName,
        this.dataType == "EDV" ? "10" : "8",
        preEventObj
      );
      setEvents("amplitude", "Impression", eventObj);
    },
    scrollOrRedirectCategory(data) {
      const { links } = data;
      let action = links[0]?.action;

      if (this.isSeparateMenuVariant) {
        let url =
          projectBasePathWithFolder +
          "/menu/" +
          localStorageFunc.storeId() +
          Utility.getUrlQueryString();
        if (
          action === "menu" ||
          action === "MENU_LIST" ||
          action === "PRODUCT_LIST"
        ) {
          url = Utility.addUpdateParam(url, "showSearchModal", false);
          url = Utility.addUpdateParam(url, "scrollTo", links[0].href);
          window.location.href = url;
        } else if (
          action === "edv" ||
          action === "edvitems" ||
          action === "edvList" ||
          action === "offers"
        ) {
          window.location.href = `${v2PwaBasePath}/${action}`;
        } else if (action === "gamifyWebview" || action === "redirect") {
          window.location.href = `${v2PwaBasePath}/${links[0]?.href}`;
        } else if (action === "web_view") {
          window.location.href = `${v2PwaBasePath}/notification`;
        } else {
          // window.location.href = `${v2PwaBasePath}/menu`;
          url = Utility.addUpdateParam(url, "showSearchModal", false);
          url = Utility.addUpdateParam(url, "scrollTo", "menuTop");
          window.location.href = url;
        }
        return;
      }

      let currentElem = this.currentElementIdInStore.map((i) => i.categoryId);
      let curElementId = currentElem.includes(Number(links[0].href));
      if (curElementId) {
        let scrollTopMargin = 70; //default
        if (this.isAnchorLinkVariant) {
          scrollTopMargin = window.screen.width <= 321 ? 70 : 102;
        }
        //console.log("categoryId is present in store");
        switch (action) {
          case "menu":
            Utility.scrollUptoTo(
              "element_catg_" + links[0].href,
              scrollTopMargin
            );
            break;
          case "MENU_LIST":
            Utility.scrollUptoTo(
              "element_catg_" + links[0].href,
              scrollTopMargin
            );
            break;
          case "PRODUCT_LIST":
            Utility.scrollUptoTo(
              "element_catg_" + links[0].href,
              scrollTopMargin
            );
            break;
          default: // set the default scroll to home
            Utility.scrollUptoMenuTop();
            break;
        }
      } else {
        if (
          action === "edv" ||
          action === "edvitems" ||
          action === "edvList" ||
          action === "offers"
        ) {
          window.location.href = `${v2PwaBasePath}/${action}`;
        } else if (action === "gamifyWebview" || action === "redirect") {
          window.location.href = `${v2PwaBasePath}/${links[0]?.href}`;
        } else if (action === "web_view") {
          window.location.href = `${v2PwaBasePath}/notification`;
        } else {
          Utility.scrollUptoMenuTop();
        }
        //console.log("categoryId is not present in store");
      }
    },
    goto(item, index) {
      let sectionName = "marketing banner";
      const preEventObj = {
        positionWithinSection: index + 1,
        category: this.data[index]?.imageUrl,
      };
      if (this.dataType && this.dataType == "EDV") {
        sectionName = "EDV";
        preEventObj["subCategory"] = "BannerTap";
      }
      const eventObj = Utility.amplitudeEventObj(
        "click",
        sectionName,
        this.dataType == "EDV" ? "10" : "8",
        preEventObj
      );
      setEvents("amplitude", "Click", eventObj);
      this.currentElementIdInStore && this.scrollOrRedirectCategory(item);
    },
    getSitePropsOfferVersion() {
      return window?._siteProps_?.props?.offer_version
        ? "?ver=" + window?._siteProps_?.props?.offer_version
        : "?ver=2.2.2";
    },
  },
  computed: {
    currentElementIdInStore() {
      return (
        this.$store.state.ProductItems.allCategoryId?.length !== undefined &&
        this.$store.state.ProductItems.allCategoryId
      );
    },
    productObserver() {
      let observer = this.$store.state.ProductItems.productObserver;
      if (
        observer &&
        this.eleIdToObserve &&
        document.getElementById(this.eleIdToObserve)
      ) {
        observer.observe(document.getElementById(this.eleIdToObserve));
      }
      return observer;
    },
    isAnchorLinkVariant() {
      let exp = this.$store.state.Config.vwoExperiments;
      if (
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_S ||
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.CONTROL
      ) {
        return true;
      } else {
        return false;
      }
    },
    isSeparateMenuVariant() {
      let exp = this.$store.state.Config.vwoExperiments;
      if (
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_U ||
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_W ||
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_X ||
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_Y ||
        Utility.getLinkRewriteFromSiteprops() ===
          PageNames.NEXTGEN_LINKREWRITE_HOME
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped></style>
